module.exports = __webpack_public_path__ + "static/media/logo.888f17aa.png";